import type { StackProps as MuiStackProps } from '@mui/material/Stack/Stack';
import MuiStack from '@mui/material/Stack/Stack';

export type StackProps = MuiStackProps;

export const Stack = MuiStack;
